import { useState } from "react";

import { SearchableMultiSelect } from "@/components/ui/SearchableMultiSelect";
import type { SearchableSelectOption } from "@/components/ui/SearchableSelect";

export const QUALITY_CASE_PRODUCT_FAMILY_OPTIONS: SearchableSelectOption[] = [
  { value: "fi_3c_b", label: "FI-3C-B" },
  { value: "fi_3c_q", label: "FI-3C-Q" },
  { value: "fi_3c_n", label: "FI-3C-N" },
  { value: "fi_5a_n", label: "FI-5A-N" },
  { value: "fi_5a_w", label: "FI-5A-W" },
  { value: "dm_1", label: "DM-1" },
  { value: "clamp", label: "Clamp" },
];

export function QualityProductFamilyPicker({
  id,
  values,
  disabled,
  onChange,
}: {
  id: string;
  values: string[];
  disabled?: boolean;
  onChange: (families: string[]) => void;
}): JSX.Element {
  const [searchValue, setSearchValue] = useState("");
  return (
    <SearchableMultiSelect
      id={id}
      variant="chips"
      addLabel="Add family"
      selectedValues={new Set(values)}
      onSelectedValuesChange={(next) => onChange([...next])}
      options={QUALITY_CASE_PRODUCT_FAMILY_OPTIONS}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      placeholder="FI-5A-W, DM-1, clamp, …"
      searchPlaceholder="Filter families"
      emptyMessage="No product family matches."
      disabled={disabled}
    />
  );
}
